import { Button, Tooltip } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { InspectionLink } from 'utils/link';
import { AddIcon, WarningIcon } from 'components/uiIcons';
import { ButtonSpan } from 'components/styles_components/span';
import Create from 'components/inspection/modal/create';
import theme from 'theme';

const CreateButton = ({
  overInspectionsLimit,
  adminRole = true,
  placeId,
  inspectionSubjectId,
  size = 'medium',
  label = <FormattedMessage id="button.add" />,
}) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();
  const intl = useIntl();
  const navigate = useNavigate();

  const button = (
    <Button
      disabled={overInspectionsLimit || !adminRole}
      size={size}
      startIcon={
        overInspectionsLimit ? <WarningIcon sx={{ color: theme.palette.error.main }} /> : null
      }
      endIcon={<AddIcon />}
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            placeId={placeId}
            inspectionSubjectId={inspectionSubjectId}
            onSuccess={(inspection) => {
              removeModal();
              setInfo('info.inspection.created');
              navigate(InspectionLink(inspection.id));
            }}
          />
        )
      }
      variant="contained"
    >
      <ButtonSpan>{label}</ButtonSpan>
    </Button>
  );

  if (!adminRole) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.place.no_admin' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  if (overInspectionsLimit) {
    return (
      <Tooltip title={intl.formatMessage({ id: 'user.plan.over_inspections_limit' })}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};

export default CreateButton;
